import { api } from "..";

import { NewUser } from "@/types/ApiResponses/User";

export interface UpdateSubDealerPayload {
  id: number;
  password?: string;
  image?: string | null;
  balance?: number;
}

export async function updateDealer(
  payload: UpdateSubDealerPayload
): Promise<NewUser> {
  const { id, ...body } = payload;
  const res = await api.client.patch(`/sub-dealers-new/${id}`, body);
  return res.data;
}
